import { gql } from '@apollo/client';

export const SUBMIT_ORDER_ADDRESS_LOCATION_CHANGE = gql`
    mutation SubmitOrderAddressLocationChange(
        $orderId: Long!
        $latitude: Float!
        $longitude: Float!
    ) {
        submitOrderAddressLocationChange(
            orderId: $orderId
            latitude: $latitude
            longitude: $longitude
        ) {
            success
            code
            message
        }
    }
`;

export interface SubmitOrderAddressLocationChangeResult {
    success: boolean;
    code: string;
    message: string;
}

export interface SubmitOrderAddressLocationChangeResponse {
    submitOrderAddressLocationChange: SubmitOrderAddressLocationChangeResult;
}

export interface SubmitOrderAddressLocationChangeVariables {
    orderId: string;
    latitude: number;
    longitude: number;
}
